import * as types from '../mutation-types'
import user from '../../api/user'
import Cookie from 'js-cookie'

const state = {
    isAuthenticated: !!Cookie.get('token'),
    user: null,
    provider: null,
};

const getters = {

    isAuthenticated: state => {
        return state.isAuthenticated
    },

    user: state => {
        return state.user
    },

    provider: state => {
        return state.provider
    }

};

const actions = {

    /**
     * Log in by requesting and storing token in local storage.
     *
     * @param commit
     * @param dispatch
     * @param tokens
     * @param remember
     * @returns {Promise.<TResult>}
     */
    login({ commit, dispatch }, tokens, remember = true) {
        Cookie.set('token', tokens['access_token'], { expires: remember ? 365 : null })
        commit(types.LOGIN);
        dispatch('getUser');
    },

    /**
     * Log out by removing token from local storage
     *
     * @param commit
     */
    logout({ commit }) {
        Cookie.remove('token');
        //router.push({ name: 'home' });
        commit(types.LOGOUT);
    },

    /**
     * Store provider object.
     *
     * @param commit
     * @param provider
     */
    setProvider({ commit }, provider) {
        commit(types.SET_PROVIDER, provider )
    },

    /**
     * Fetch user from the SOT and commit
     *
     * @param commit
     * @returns {Promise.<TResult>}
     */
    getUser({ commit }) {
        return user.get()
            .then(response => {
                commit(types.UPDATE_USER, { user: response.data });
                return response;
            })
    },

    /**
     * Update user and commit the response
     *
     * @param commit
     * @param userData
     * @returns {Promise.<TResult>}
     */
    updateUser({ commit }, userData ) {
        return user.update(userData)
            .then(response => {
                commit(types.UPDATE_USER, { user: response.data });
                return response;
            })
    }

};

const mutations = {

    [types.LOGIN] (state) {
        state.isAuthenticated = true;
    },

    [types.LOGOUT] (state) {
        state.isAuthenticated = false;
    },

    [types.UPDATE_USER] (state, { user }) {
        state.user = user;
    },

    [types.SET_PROVIDER] (state, provider) {
        state.provider = provider
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js